import React, { useEffect, useState } from "react";
import CallAPI from "../utility/functions/getData";
import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "../utility/Redux/security";
import {
  selectCompanyAddress,
  selectPrefix,
  selectWidth,
} from "../utility/Redux/profile";
import moment from "moment";
import { FormatNumber2 } from "../utility/functions/formatNumber";

import { setSpinnerLoading } from "../utility/Redux/modal";
import "../styles/print.css";

const VoucherEntryPrint = ({ IsVoucher, printRef, handlePrint }) => {
  const company = useSelector(selectCompanyAddress);
  const width = useSelector(selectWidth);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "500px",
    width: "auto",
    padding: "2px",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "white",
  };
  const [voucherDetails, setVoucherDetails] = useState([]);
  const prefix = useSelector(selectPrefix);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);

  const getVoucherData = () => {
    dispatch(setSpinnerLoading("Loading"));
    const data = {
      table_prefix: prefix,
      VOUCHER_NO: IsVoucher,
    };

    CallAPI(
      "/api/Accounts/loadVoucher",
      data,
      token,
      (o) => {
        if (!o.data.error) {
          if (o.data.response[0]) {
            setVoucherDetails(o.data.response);
          }
        }
      },
      dispatch,
      () => {
        dispatch(setSpinnerLoading(false));
      }
    );
  };

  useEffect(() => {
    if (IsVoucher) {
      getVoucherData();
    }
  }, [IsVoucher]);

  return (
    <VoucherPrint
      voucherDetails={voucherDetails}
      company={company}
      handlePrint={handlePrint}
      printRef={printRef}
    />
  );
};

const VoucherPrint = ({ voucherDetails, company, printRef }) => {
  return (
    <div
      ref={printRef}
      id="print-component"
      className="w-[800px] mx-auto my-4 p-2 text-xs font-mono print:block hidden  border border-black"
    >
      {/* Header */}
      <div className="text-center font-bold text-lg mb-2">VOUCHER ENTRY</div>

      {/* Company Info */}
      <div className="border border-dotted border-black mb-2">
        <div className="p-2">
          <div className="font-bold">{company.companyName}</div>
          <div>
            {company.address}, {company.city}, {company.state}
          </div>
          <div>
            Mob: {company.mobile} | Email: {company.email}
          </div>
          <div>GSTIN: {company.regdNo}</div>
        </div>
      </div>

      {/* Voucher Info */}
      {voucherDetails[0] && (
        <div className="grid grid-cols-2 border border-dotted border-black mb-2">
          <div className="p-2 border-r border-dotted border-black">
            <div>
              <strong>Voucher No.:</strong> {voucherDetails[0].VOUCHER_NO}
            </div>
            <div>
              <strong>Voucher Type:</strong> {voucherDetails[0].VOUCHER_TYPE}
            </div>
          </div>
          <div className="p-2">
            <strong>Date:</strong>{" "}
            {moment(voucherDetails[0].DATE).format("DD-MM-YYYY")}
          </div>
        </div>
      )}

      {/* Table Header */}
      <div className="grid grid-cols-4 text-center border border-dotted border-black font-bold">
        <div className="border-r border-dotted border-black p-1">
          ACCOUNT NO.
        </div>
        <div className="border-r border-dotted border-black p-1">
          ACCOUNT NAME
        </div>
        <div className="border-r border-dotted border-black p-1">DEBIT</div>
        <div className="p-1">CREDIT</div>
      </div>

      {/* Table Rows */}
      {voucherDetails?.map((v, i) => (
        <div
          key={i}
          className="grid grid-cols-4 text-center border-l border-r border-b border-dotted border-black"
        >
          <div className="border-r border-dotted border-black p-1">
            {v.ACCOUNT_NO}
          </div>
          <div className="border-r border-dotted border-black p-1 text-left">
            {v.ACCOUNT_NAME}
          </div>
          <div className="border-r border-dotted text-right border-black p-1">
            {v.DEBIT > 0 ? FormatNumber2(v.DEBIT) : ""}
          </div>
          <div className="p-1  text-right">
            {v.CREDIT > 0 ? FormatNumber2(v.CREDIT) : ""}
          </div>
        </div>
      ))}

      {/* Narration */}
      <div className="border-l border-r border-dotted border-black p-2">
        <strong>Narration:</strong> {voucherDetails[0]?.NARRATION || "N/A"}
      </div>

      {/* Totals */}
      <div className="grid grid-cols-4 text-center border border-dotted border-black font-bold">
        <div className="col-span-2 border-r border-dotted border-black p-1">
          Total
        </div>
        <div className="border-r border-dotted  text-right border-black p-1">
          {FormatNumber2(
            voucherDetails.reduce((acc, curr) => acc + curr.DEBIT, 0)
          )}
        </div>
        <div className="p-1  text-right">
          {FormatNumber2(
            voucherDetails.reduce((acc, curr) => acc + curr.CREDIT, 0)
          )}
        </div>
      </div>

      <div className="grid grid-cols-3 mt-[100px] text-center border border-dotted border-black  text-xs">
        <div className="border-r border-dotted border-black p-1">
          ENTERED BY
        </div>
        <div className="border-r border-dotted border-black p-1">
          CHECKED BY
        </div>
        <div className="p-1">AUTHORIZED BY</div>
      </div>

      <div className="flex justify-between text-xs mt-2">
        <div>
          Powered by: <strong>genius office</strong>
        </div>
      </div>
    </div>
  );
};

export default VoucherEntryPrint;
